import { useConfigProvider } from '@/context/ConfigProvider';
import { useUserProvider } from '@/context/UserProvider';
import { EventName } from '@/shared/event-types';
import { ga_logEvent } from '@/shared/ga';
import { App, Button } from 'antd';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { useEffect, useMemo } from 'react';
import { CommonBackContent } from '../Layouts/CommonBackContent';
import styles from './index.module.less';

import dynamic from 'next/dynamic';
import ExampleItemList from './ExampleItemList';

const BottomBtnContent = dynamic(() => import('./BottomBtnContent'), {
  ssr: false,
});

const ExamplesContent = () => {
  const { t } = useTranslation('common');
  const { isLogin, onOpenLoginModal, onChangedLoginView } = useUserProvider();
  const router = useRouter();
  const { isBlogWeb } = useConfigProvider();
  const { message } = App.useApp();

  useEffect(() => {
    return () => {
      if (isLogin) {
        ga_logEvent(EventName.Sample_View);
      }
    };
  }, []);

  useEffect(() => {
    if (isBlogWeb) {
      router.push('/instagram-tracking-blog');
      return;
    }
  }, [isLogin, isBlogWeb]);

  const onGoToDashboard = () => {
    if (isLogin) {
      router.push(`/dashboard?alertType=1`);
    } else {
      onChangedLoginView(false);
      onOpenLoginModal(true);
    }
  };

  const getContent = useMemo(() => {
    return (
      <CommonBackContent style={{ minHeight: '100vh' }}>
        <div className={styles.content}>
          <div className={styles.topContainer}>
            <h1 style={{ display: 'none', width: 0, height: 0 }}>
              {t('Celebrity Instagram Tracking & Analytics Report Sample')}
            </h1>
            <div className={styles.title}>{t('Analytics Report Sample')}</div>
            <p>{t('HereIsADynamicDemonstrationOfRealTimeInstagramAccountMonitoringAtItsFinest_Desc')}</p>
            <p>{t('SelectAnAccountFromTheListBelowToViewAnAnalyticsSample')}</p>
          </div>

          <ExampleItemList />

          <div className={styles.bottomContent}>
            <Button type="primary" className={styles.registerBtn} onClick={onGoToDashboard}>
              {t('Add Account To Track')}
            </Button>
            <p>{t('OurInstagramDataReportsFocusSolelyOnDataCompilationAndAnalysis_Desc')}</p>
          </div>
        </div>
        <BottomBtnContent />
      </CommonBackContent>
    );
  }, []);

  if (isBlogWeb) {
    return <></>;
  }
  return <>{getContent}</>;
};

export default ExamplesContent;
